<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="close_"
    @keydown.esc="close_"
    persistent
    max-width="797px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">mdi-calendar-clock</v-icon>
          {{ `${(id === 0 ? lang.scheduler.new.title : lang.scheduler.edit.title_(id))}` }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="close_">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-1 pt-2">
        <v-container
          v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
          class="px-0 overflow-y-auto dialog-scrollbar"
        >
          <div class="dialog-scrollbar-inside">
            <v-form
              ref="SaveForm"
              v-model="valid"
              lazy-validation
              :disabled="get_interface.loading"
              class="schedule-form"
            >
              <v-row class="schedule-form-row mh-70">
                <v-col cols="12">
                  <v-text-field
                    v-model="selected.title"
                    :label="lang.scheduler.new.sch_title"
                    :rules="lang.scheduler.new.rules.title"
                    :loading="get_interface.loading"
                    :disabled="get_interface.loading"
                    autocomplete="new-password"
                    filled
                  ></v-text-field>
                </v-col>
              </v-row>
              <template v-if="noOrder">
                <v-row v-if="selected.customer < 1 || id > 0" class="pa-0">
                  <v-col cols="12" class="pa-1 py-0 pb-3">
                    <Order
                      v-model="selected.order"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="selected.order < 1 || id > 0" class="pa-0">
                  <v-col cols="12" class="pa-1 py-0 pb-3">
                    <Customer
                      v-model="selected.customer"
                    />
                  </v-col>
                </v-row>
              </template>
              <v-row class="schedule-form-row">
                <Widget
                  :value="selected.selected"
                  :edit_value="selected"
                  :items="selected.list || []"
                  :services="services"
                  :others="others"
                  :errors="errors"
                  :edit="id > 0"
                  @input="changed"
                />
              </v-row>
            </v-form>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="close_">{{ lang.scheduler.new.close }}</v-btn>
        <v-btn
          @click.stop="save_()"
          color="green darken-1"
          text
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          {{ lang.scheduler.actions.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Widget from './Widget'
import Order from '@/components/orders/templates/AutoComplete'
import Customer from '@/components/customers/templates/SingleAutoComplete'

import appdata from '@/mixins/appdata'
import save from '@/mixins/defaults/save'
import utils from '@/mixins/utils'

export default {
  components: { Widget, Order, Customer },
  mixins: [ appdata, save, utils ],
  props: {
    schedules: {
      type: Array,
      default: () => {
        return []
      }
    },
    services: {
      type: Array,
      default: () => {
        return []
      }
    },
    noOrder: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    valid: false,
    errors: [],
    datemenu: false,
    timemenu: false
  }),
  computed: {
    others () {
      return (this.schedules || [])
        .filter(sch => sch.UUID !== this.selected.UUID)
        .reduce((add, val) => add.concat(val.selected), [])
    }
  },
  methods: {
    close_ () {
      this.$emit('closed', true)
    },
    changed (newVal) {
      this.$set(this.selected, 'selected', [ ...newVal ])
    },
    validate_ () {
      let form = this.selected,
          schedules = form.selected || []
      this.errors = []
      if (schedules.length > 0) {
        schedules.forEach((sch) => {
          let employees = sch.employees || []
          if (employees.length > 0) {
            //
          } else {
            this.errors.push({ cod: 2, UUID: sch.UUID})
          }
        })
      } else {
        this.errors.push({ cod: 1, UUID: 0})
      }
      return (this.errors.length <= 0)
    },
    save_ () {
      if (this.$refs.SaveForm.validate() && this.validate_()) {
        let selected = this.selected || false
        if (selected) {
          if (typeof selected.UUID === 'undefined' || !selected.UUID) selected.UUID = this.getRandomUnique()
          return (this.noOrder ? this.save__() : this.$emit('saved', selected))
        } else {
          return false
        }
      }
    },
    save__ () {
      let save = JSON.parse(JSON.stringify({ ...this.selected }))
      save.selected = (save.selected || [])
        .map(stds => {
          stds.employees = (stds.employees || [])
            .map(emp => {
              if (emp !== null) {
                return (typeof emp === 'object' ? emp.id : emp)
              }
            })
          delete stds.av_employees
          return stds
        })
      console.log('dispatch save', save)
      this.$store.dispatch('saveData', { page: 7, data: save, item: this.id })
    }
  }
}
</script>

<style scoped src="@/components/scheduler/styles/save.scss" lang="scss"></style>
